import React from "react";
//import PropTypes from "prop-types";
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";


import { authenticate, confirmUserLogin } from '../../actions/auth'

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import InputAdornment from "material-ui/Input/InputAdornment";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import LoginCard from "components/Cards/LoginCard.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import UserNotifications from "components/UserNotifications/UserNotifications.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      //cardAnimaton: "cardHidden",
      supportSocial: false,  
      username: "",
      password: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);

  }

  handleSubmit(event){
    event.preventDefault();
    const { username, password } = this.state

    this.props.dispatchAuthenticate(username, password)
    .then((data)=>{
        if(this.props.auth.loggedIn){
          this.props.history.push('/dashboard');
        }
    });

  }

  handleInput(e){
    this.setState({ [e.target.name]: e.target.value });
  }

  componentDidMount() {
    if(this.props.location.state&&this.props.location.state.username){
      this.setState({username:this.props.location.state.username});
    }

  }
  render() {
    const { classes, auth } = this.props;

    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <UserNotifications 
              notification={auth.signInError} 
              notifications={auth.signInErrorMessage} 
              onClose={() => this.setState({ notification: false })} 
            />          
            <ItemGrid xs={12} sm={6} md={4}>
              <form>
                  <LoginCard
                  customCardClass={classes[this.state.cardAnimaton]}
                  headerColor="rose"
                  cardTitle="Login"
                  footerAlign="center"
                  footer={
                    <div>
                      <Button color="primary" wd size="lg"  onClick={(e) => this.handleSubmit(e)}>
                        Let&apos;s Go
                      </Button>
                      <Link to={{
                          pathname: '/forgot-password',
                          state: {  },
                        }}>Forgot Password</Link>
                      </div>
                  }
                  socials={this.state.supportSocial?([
                    "fab fa-facebook-square",
                    "fab fa-twitter",
                    "fab fa-google-plus"
                  ].map((prop, key) => {
                    return (
                      <Button
                        color="simple"
                        justIcon
                        key={key}
                        customClass={classes.customButtonClass}
                      >
                        <i className={prop} />
                      </Button>
                    );
                  })):false}
                  content={
                    <div>
                      <CustomInput
                        labelText="Username.."
                        id="firstname"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Face className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: this.handleInput,
                          value: this.state.username,
                          name: "username", 
                          disabled: auth.isAuthenticating,                         
                        }}
                      />
                      <CustomInput
                        labelText="Password"
                        id="password"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockOutline
                                className={classes.inputAdornmentIcon}
                              />
                            </InputAdornment>
                          ),
                            onChange: this.handleInput,
                            name: "password",                          
                            disabled: auth.isAuthenticating,                         
                        }}
                      />
                    </div>
                  }
                />
              </form>
            </ItemGrid>
          </GridContainer>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  dispatchConfirmUserLogin: authCode => confirmUserLogin(authCode),
  dispatchAuthenticate: (username, password) => authenticate(username, password)
}

const mapStateToProps = (state, props) => {
  return {
    page: props.location.pathname.replace("/pages/","").replace("-","_"),
    translate: getTranslate(state.localize),
    auth: state.auth
  }
}


export default compose(
  withStyles(loginPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(LoginPage);


// WEBPACK FOOTER //
// ./src/views/User/LoginPage.jsx